// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"840a1bdd","460":"72d718ff","871":"bcdc0eef"}[chunkId] + ".chunk.js";
};